import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import ShoppingCart from './pages/shopping-cart';
import HomeLanding from './pages/home-landing';
import LoginPage from './pages/login';
import UserAccount from './pages/user-account';
import ProfileDetails from './pages/profile-details';
import Register from './pages/register';
import MenuCatalog from './pages/menu-catalog';
import TableReservation from './pages/table-reservation';
import OrderTracking from './pages/order-tracking';
import ShipmentTracking from './pages/shipment-tracking';
import CheckoutSuccess from './pages/checkout-success';
import CustomerDashboard from './pages/customer-dashboard';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<HomeLanding />} />
        <Route path="/shopping-cart" element={<ShoppingCart />} />
        <Route path="/home-landing" element={<HomeLanding />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/user-account" element={<UserAccount />} />
        <Route path="/profile-details" element={<ProfileDetails />} />
        <Route path="/register" element={<Register />} />
        <Route path="/menu-catalog" element={<MenuCatalog />} /> {/* Services Catalog */}
        <Route path="/table-reservation" element={<TableReservation />} /> {/* Shipment Booking */}
        <Route path="/order-tracking" element={<OrderTracking />} /> {/* Shipment Tracking */}
        <Route path="/shipment-tracking" element={<ShipmentTracking />} />
        <Route path="/checkout-success" element={<CheckoutSuccess />} />
        <Route path="/customer-dashboard" element={<CustomerDashboard />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;